import { render } from "./ReadOnlyInput.vue?vue&type=template&id=cca13a52&scoped=true"
import script from "./ReadOnlyInput.vue?vue&type=script&lang=js"
export * from "./ReadOnlyInput.vue?vue&type=script&lang=js"

import "./ReadOnlyInput.vue?vue&type=style&index=0&id=cca13a52&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca13a52"]])

export default __exports__